import Vue from "vue";

/**
 * Class LeadTabulation Service
 */
export default class LeadTabulationService extends Vue {
  private customActions = {
    status: {
      method: "GET",
      url:
        "lead/tabulation/related-status/{statusId}"
    },
    indexAllFilters: {
      method: "GET",
      url:
        "lead/tabulation/status/{statusId}/related-status/{relatedStatusId}/related-channel/{relatedChannelId}"
    }
  };
  private resource: any = this.$resource(
    "lead/tabulation{/id}",
    {},
    this.customActions
  );

  // GET all
  public index() {
    return this.resource.get({ }).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }

  // GET all with status
  public status(statusId: number) {
    return this.resource.status({ statusId }).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }

  // index with all filters
  public indexAllFilters(statusId: number, relatedStatusId: number, relatedChannelId: number) {
    return this.resource.indexAllFilters({ statusId, relatedStatusId, relatedChannelId }).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }

  // GET one
  public show(id: number) {
    return this.resource.get({ id }).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }

  // POST
  public store(data: any) {
    return this.resource.save({ }, data).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }

  // PUT
  public update(id: number, data: any) {
    return this.resource.update({ id }, data).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }

  // DELETE
  public delete(id: number) {
    return this.resource.delete({ id }).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }
}
